export default "__VITE_ASSET__5R8jEjlY__"